import { Box, Text } from 'src/components/UI'
import ContactInformation from './ContactInformation/ContactInformation'
import ContactInformationItem from './ContactInformation/ContactInformationItem'

const email = 'care@homecredit.co.id'
const phoneNumber = '021 2953 9600'
const whatsappLink = 'https://wa.me/622129539600'

const DefaultContactInformation = () => {
  return (
    <Box alignItems={'center'} margin={['0 0 24px', '24px 0 64px']}>
      <ContactInformation title="Hubungi Home Credit Indonesia">
        <ContactInformationItem type={'mail'} href={`mailto:${email}`}>
          <Text>Kirimkan email ke</Text>
          <Text style={{ color: 'var(--color-red)' }}>{email}</Text>
        </ContactInformationItem>
        <ContactInformationItem type={'phone'} href={`tel:${phoneNumber.replace(/\s+/g, '-')}`}>
          <Text>Hubungi Home Credit Indonesia</Text>
          <Text style={{ color: 'var(--color-red)' }}>{phoneNumber}</Text>
          <Text>Setiap hari, 07.00 – 20.00 WIB</Text>
          <Text style={{ fontStyle: 'italic' }}>(kecuali hari libur nasional)</Text>
        </ContactInformationItem>
        <ContactInformationItem type={'whatsapp'} href={whatsappLink}>
          <Text>Chat WhatsApp resmi kami di</Text>
          <Text style={{ color: 'var(--color-red)' }}>{phoneNumber}</Text>
          <Text>Setiap hari, 24 Jam</Text>
        </ContactInformationItem>
      </ContactInformation>
    </Box>
  );
}

export default DefaultContactInformation
